var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h2',{staticClass:"text-center text-h5"},[_vm._v(_vm._s(_vm.failedLogins.lastDay))])
}
var staticRenderFns = []

export { render, staticRenderFns }